import React, {Fragment} from 'react';
import {Link} from 'dva/router';
import './index.scss'
import IMGNull from '../../assets/images/loading_bg_template.png'
import CommonUtil from "../../utils/common-util";
import StorageUtil from "../../utils/storage-util";
import {LocalConst} from "../../utils/constant";
import {injectIntl} from "react-intl"
import ImgAdapt from "../img-adapt";

const GoodsCard = props => {
    const {goods, showGoodsListAction, intl} = props;
    const isLogin = CommonUtil.isLogin();
    const showGoodsUnit = StorageUtil.getItem(LocalConst.showGoodsUnit) === 2;
    const currencySymbol = StorageUtil.getItem(LocalConst.currencySymbol) || '￥';
    return (
        <Link to={`/goods/detail/${goods.id_}`} className='goods-card'>
            <div className="img-box">
                <ImgAdapt src={goods.main_img_ ? `${goods.main_img_}_800` : IMGNull} alt=""/>
            </div>
            <div className="info-box">
                <div className="name">{goods.name_}</div>
                <div className="tag-box">
                    {/*       {
                        (goods.goodsPromotionTypes || []).map((tag, index) => {
                            return (
                                <span className="tag" key={index}>{DataConstant.goodsPromotion[tag]}</span>
                            )
                        })
                    }*/}
                    {
                        (goods.tagList || []).map((tag, index) => {
                            const tagStyle = {
                                background: '#' + tag.color,
                            };
                            return (
                                <span className="tag" style={tagStyle} key={index}>{tag.name}</span>
                            )
                        })
                    }
                </div>
                <div className="price">
                    {
                        !isLogin && !goods.allow_client_price_ ? (
                            <span className="txt">{intl.messages['DLHCKJG'] || '登录后查看价格'} >></span>
                        ) : (
                            <Fragment>
                                <span className="symbol">{currencySymbol}</span>
                                <span className="txt">
									{CommonUtil.priceScale(goods.client_price_ || 0)}
                                    {goods.product_ids_ && goods.product_ids_.split(',').length > 1 ? '起' : ''}
								</span>
                                {
                                    showGoodsUnit ? (
                                        `/${goods.unit_name_}`
                                    ) : ''
                                }
                            </Fragment>
                        )
                    }
                </div>
                <div className="goods-info-row to-cart">
                    <span role={'none'} onClick={(event) => showGoodsListAction(event, goods)}><i className="iconfont icon-cart"/></span>
                </div>
            </div>
        </Link>
    )
};
export default injectIntl(GoodsCard)
